import { Box, Icon, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { PiSliders } from 'react-icons/pi';
import { Navigate, useNavigate } from 'react-router-dom';
import { CellValue } from 'react-table';

import Button from 'components/Button';
import Table from 'components/Table';
import Title from 'components/Title';
import { routePaths } from 'global/routePaths';
import { useFetchCustomFieldModule } from 'hooks/customField/useFetchCustomFieldModule';
import { useFeatureList } from 'store/useFeatureStore';

const CustomField = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useFetchCustomFieldModule();

  const featureList = useFeatureList();

  const columns = useMemo(
    () => [
      {
        Header: 'Module',
        accessor: 'label',
        width: 200,
      },
      {
        Header: 'Active Fields',
        accessor: 'counts.active',
        Cell: (cell: CellValue) => (
          <Text color="success.500" fontWeight="bold">
            {cell.value}
          </Text>
        ),
      },
      {
        Header: 'Archived Fields',
        accessor: 'counts.deactivated',
        Cell: (cell: CellValue) => (
          <Text color="gray.500" fontWeight="bold">
            {cell.value}
          </Text>
        ),
      },
      {
        Header: '',
        accessor: 'action',
        width: 200,
        Cell: (data: CellValue) => {
          return (
            <Button
              rightIcon={<Icon as={PiSliders} />}
              onClick={() => handleConfigureFieldClick(data.row.original?.attribute)}
            >
              Configure Fields
            </Button>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleConfigureFieldClick = (module: string) => {
    navigate(routePaths.companySettings.customFields.module.replace(':module', module));
  };

  if (!featureList?.custom_fields) return <Navigate replace to={routePaths.companySettings.general} />;

  return (
    <div>
      <Box mb={{ base: '2', md: '0' }}>
        <Title hideBackButton={true}> Custom Fields </Title>
      </Box>
      <Table data={data?.payload || []} columns={columns} isLoading={isLoading} />
    </div>
  );
};

export default CustomField;
